import { ContentTemplate, Grid, TitleHeader } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import ImportantSection from './ImportantSection';
import NotesForAASection from './NotesForAASection';

const useStyles = makeStyles()((theme) =>
({
  segmentContainer: {
    marginBottom: theme.spacing(5),
  },
}));

const ImportantNotesContent = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <>
      <TitleHeader
        title={t('accessArrangement->>AccessArrangementRoute.ApplyforAccessArrangements')}
      />
      <ContentTemplate isDividerBottom>
        <Grid className={classes.segmentContainer}>
          <ImportantSection />
        </Grid>
      </ContentTemplate>
      <ContentTemplate isDividerBottom continuous>
        <Grid className={classes.segmentContainer}>
          <NotesForAASection />
        </Grid>
      </ContentTemplate>
    </>
  );
};

export default ImportantNotesContent;
